import { IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import buildLogo from 'components/b2b/Logo';

import { ReactComponent as Camera } from 'assets/camera-bam.svg';
import { ReactComponent as Home } from 'assets/home-bam.svg';
import { ReactComponent as Language } from 'assets/languages-bam.svg';
import { ReactComponent as Light } from 'assets/light-bam.svg';
import { ReactComponent as Logo } from 'assets/logo-bam-karaokebox.svg';
import { ReactComponent as Photo } from 'assets/photo-bam.svg';
import ColormapInterface from 'shared-types/colormapinterface';
import { borderRadius, colorFilterUsage, getSpacing } from 'stylesheetB2b';
import STANDARDDEFAULTSRC from 'assets/logo-tsl.svg';
import { getDefaultLogo } from 'types/logo/logo';

const logoModel = getDefaultLogo(STANDARDDEFAULTSRC);

const TslLogoImg = buildLogo(logoModel);

const HeaderHeight = getSpacing(13);

const getHeaderBorder = (colors: ColormapInterface) =>
  `solid ${getSpacing(0.2)} ${colors.homeBorder}`;

export const StyledHeader = styled.div<{ colors: ColormapInterface }>`
  border-top: ${({ colors }) => getHeaderBorder(colors)};
  border-right: ${({ colors }) => getHeaderBorder(colors)};
  flex-shrink: 0;
  height: ${HeaderHeight};
  border-bottom: solid 1px ${({ colors }) => colors.homeBorder};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const headerIconCommonStyle = (colors: ColormapInterface) => `
  height: ${HeaderHeight};
  width: ${HeaderHeight};
  border: solid ${getSpacing(0.2)} ${colors.homeBorder};
  padding:${getSpacing(4)};
`;

const lastRightHeaderIconStyle = (colors: ColormapInterface) => `
  ${headerIconCommonStyle(colors)}
  border-right: none;
`;

export const BamLogo = styled(Logo)`
  height: ${getSpacing(9)};
  width: ${getSpacing(20)};
`;

export const HomeIcon = styled(Home) <{ colors: ColormapInterface }>`
  ${({ colors }) => headerIconCommonStyle(colors)}
`;

export const CameraIcon = styled(Camera) <{ colors: ColormapInterface }>`
  ${({ colors }) => lastRightHeaderIconStyle(colors)}
`;

export const PhotoIcon = styled(Photo) <{ colors: ColormapInterface }>`
  ${({ colors }) => headerIconCommonStyle(colors)}
`;

export const LanguageIcon = styled(Language) <{ colors: ColormapInterface }>`
  ${({ colors }) => headerIconCommonStyle(colors)}
`;

export const LightIcon = styled(Light) <{ colors: ColormapInterface }>`
  ${({ colors }) => headerIconCommonStyle(colors)}
`;

export const HeaderIconGroup = styled.div`
  display: flex;
`;

export const HeaderIconButton = muiStyled(IconButton)(() => ({
  padding: 0,
  position: 'relative',
}));

export const HighlightPoint = styled.div<{ colors: ColormapInterface }>`
  width: ${getSpacing(2)};
  height: ${getSpacing(2)};
  margin: ${getSpacing(2)};
  border-radius: ${borderRadius.rounded};
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ colors }) => colors.highlightPoint};
`;

export const StyledTslLogo = styled(TslLogoImg)`
  height: ${getSpacing(8)};
  filter: ${colorFilterUsage.tslLogo};
  pointer-events: none;
`;
StyledTslLogo.displayName = 'StyledTslLogo';

export const QRCodeContainer = styled.div`
  margin-right: ${getSpacing(4)};
  cursor: pointer;
`;

export const ModalContent = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};